import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, Text } from 'react-native';
import { Large } from '@dbk/ui-text'
import { XSmall, Small } from '../../../../../../src/components/common/text';
import AssetItem from '../../../../../../src/components/asset/asset-item';
import TableRow from '../../../../../../src/components/common/table-row';
import { Currency } from '../../../../../../src/components/common/number';
import ListView from '../../../../../../src/components/common/list-view';
import styles from '../../../../../../src/screens/income-history/_transaction-table-tablet/transaction-history-table.styles'
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import SimpleDate from '../../../../../../src/components/common/date';
import { createContainer } from '@dbk-legacy/muster/react';
import { INCOME_EXPENSE } from '../../../../../../src/constants';

class TransactionHistoryTable extends PureComponent {
   
  renderAssetRow(asset) {
    return ( 
    // <div className="row" style={{paddingLeft: 10}}>

    //   <div className="columns small-12">
      <View>
      <TableRow>
        <View>
          <Large secondary>{asset.ieDesc}</Large>
        </View>
      </TableRow>
      <TableRow style={styles.rowStyles}>
        <TableRow.Column width={1} align="left" testID="description">
          <SimpleDate value={asset.ieTradeDate} renderProps={{ size: 'small' }} />
        </TableRow.Column>
        <TableRow.Column width={1} align="right style">
          <Small>{asset.ieRefNo} </Small>
        </TableRow.Column>
        <TableRow.Column width={1} align="right">
          <SimpleDate value={asset.ieValDate} renderProps={{ size: 'small' }} />
        </TableRow.Column>
        <TableRow.Column width={1} align="right">
          <Currency
            renderProps={{
              size: 'small',
              testID: 'Interest-amount-value'
            }}
            currency={asset.iePosCcy}
            value={asset.ieTrnAmtPosCcy}
          />
        </TableRow.Column>
        <TableRow.Column width={1} align="right">
          <Currency
            renderProps={{
              size: 'small',
              testID: 'market-value',
            }}
            value={asset.ieTrnAmtRefCcy}
          />
        </TableRow.Column>

      </TableRow>
      </View>
      //</div>
    //</div> 
    )
  }

  setTypeColor(val) {
    let oReturn = {
      fill: INCOME_EXPENSE.expense
    }
    if (val >= 0) {
      oReturn.fill = INCOME_EXPENSE.income;
    }
    return (oReturn);
  }

  render() {
    const { data, type, i18n: { messages } } = this.props;
    if (!data || data == null || data.length == 0) {
      return (
        <View><Text>{messages['app.profile.consolidatesetup.dataRes']}</Text></View>
      );
    }
    return (
      <View style={styles.containerStyle}>
        {
          <ListView
            rows={data}
            testID="currencyList"
            renderRow={(asset) => {
              return (
                <ListView.Row markerStyle={this.setTypeColor(asset.ieTrnAmtRefCcy)} >
                  <AssetItem>



                    {this.renderAssetRow(asset)}
                    
                  </AssetItem>
                </ListView.Row>
              );
            }}
          />
        }
      </View>
    );
  }
}
TransactionHistoryTable.propTypes = {
  type: PropTypes.string,
  data: PropTypes.array,
  currency: PropTypes.string,
};

export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle isPage={true} />,
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(TransactionHistoryTable);
